
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../_models/user';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public currentUserSubject: BehaviorSubject<User> = new BehaviorSubject<User>(null);
  public currentUser: Observable<User>;

  public logout(): any {
    this.currentUserSubject.next(null);
    localStorage.removeItem("currentUser");
  }

  public login(username: string, password: string) {
    return this.http.post<any>(`${environment.apiUrl}/Users/Authenticate`, { username, password }).pipe(map(user => {
      localStorage.setItem('currentUser', JSON.stringify(user));

      this.currentUserSubject.next(user);
      return user;
    }));

  }

  constructor(private http: HttpClient) {
    var currentUser: User = <User> JSON.parse(localStorage.getItem('currentUser'));

    if (currentUser != null) {
      this.currentUserSubject.next(currentUser);
    }
  }
}
